import * as ambassadorWixFormsAiV1ChatSettings from './forms-ai-v1-chat-settings-chat-settings.http.js';
import * as ambassadorWixFormsAiV1ChatSettingsTypes from './forms-ai-v1-chat-settings-chat-settings.types.js';
import * as ambassadorWixFormsAiV1ChatSettingsUniversalTypes from './forms-ai-v1-chat-settings-chat-settings.universal.js';

export type __PublicMethodMetaInfo<
  K = string,
  M = unknown,
  T = unknown,
  S = unknown,
  Q = unknown,
  R = unknown
> = {
  getUrl: (context: any) => string;
  httpMethod: K;
  path: string;
  pathParams: M;
  __requestType: T;
  __originalRequestType: S;
  __responseType: Q;
  __originalResponseType: R;
};

export function createChatSettings(): __PublicMethodMetaInfo<
  'POST',
  {},
  ambassadorWixFormsAiV1ChatSettingsUniversalTypes.CreateChatSettingsRequest,
  ambassadorWixFormsAiV1ChatSettingsTypes.CreateChatSettingsRequest,
  ambassadorWixFormsAiV1ChatSettingsUniversalTypes.CreateChatSettingsResponse,
  ambassadorWixFormsAiV1ChatSettingsTypes.CreateChatSettingsResponse
> {
  const payload = {} as any;

  const getRequestOptions =
    ambassadorWixFormsAiV1ChatSettings.createChatSettings(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'POST',
    path: '/v1/chat-settings',
    pathParams: {},
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function updateChatSettings(): __PublicMethodMetaInfo<
  'PATCH',
  { chatSettingsId: string },
  ambassadorWixFormsAiV1ChatSettingsUniversalTypes.UpdateChatSettingsRequest,
  ambassadorWixFormsAiV1ChatSettingsTypes.UpdateChatSettingsRequest,
  ambassadorWixFormsAiV1ChatSettingsUniversalTypes.UpdateChatSettingsResponse,
  ambassadorWixFormsAiV1ChatSettingsTypes.UpdateChatSettingsResponse
> {
  const payload = { chatSettings: { id: ':chatSettingsId' } } as any;

  const getRequestOptions =
    ambassadorWixFormsAiV1ChatSettings.updateChatSettings(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'PATCH',
    path: '/v1/chat-settings/{chatSettings.id}',
    pathParams: { chatSettingsId: 'chatSettingsId' },
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function deleteChatSettings(): __PublicMethodMetaInfo<
  'DELETE',
  { chatSettingsId: string },
  ambassadorWixFormsAiV1ChatSettingsUniversalTypes.DeleteChatSettingsRequest,
  ambassadorWixFormsAiV1ChatSettingsTypes.DeleteChatSettingsRequest,
  ambassadorWixFormsAiV1ChatSettingsUniversalTypes.DeleteChatSettingsResponse,
  ambassadorWixFormsAiV1ChatSettingsTypes.DeleteChatSettingsResponse
> {
  const payload = { chatSettingsId: ':chatSettingsId' } as any;

  const getRequestOptions =
    ambassadorWixFormsAiV1ChatSettings.deleteChatSettings(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'DELETE',
    path: '/v1/chat-settings/{chatSettingsId}',
    pathParams: { chatSettingsId: 'chatSettingsId' },
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function getChatSettings(): __PublicMethodMetaInfo<
  'GET',
  { chatSettingsId: string },
  ambassadorWixFormsAiV1ChatSettingsUniversalTypes.GetChatSettingsRequest,
  ambassadorWixFormsAiV1ChatSettingsTypes.GetChatSettingsRequest,
  ambassadorWixFormsAiV1ChatSettingsUniversalTypes.GetChatSettingsResponse,
  ambassadorWixFormsAiV1ChatSettingsTypes.GetChatSettingsResponse
> {
  const payload = { chatSettingsId: ':chatSettingsId' } as any;

  const getRequestOptions =
    ambassadorWixFormsAiV1ChatSettings.getChatSettings(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'GET',
    path: '/v1/chat-settings/{chatSettingsId}',
    pathParams: { chatSettingsId: 'chatSettingsId' },
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function queryChatSettings(): __PublicMethodMetaInfo<
  'GET',
  {},
  ambassadorWixFormsAiV1ChatSettingsUniversalTypes.QueryChatSettingsRequest,
  ambassadorWixFormsAiV1ChatSettingsTypes.QueryChatSettingsRequest,
  ambassadorWixFormsAiV1ChatSettingsUniversalTypes.QueryChatSettingsResponse,
  ambassadorWixFormsAiV1ChatSettingsTypes.QueryChatSettingsResponse
> {
  const payload = {} as any;

  const getRequestOptions =
    ambassadorWixFormsAiV1ChatSettings.queryChatSettings(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'GET',
    path: '/v1/chat-settings/query',
    pathParams: {},
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export {
  ChatSettings as ChatSettingsOriginal,
  ExtendedFields as ExtendedFieldsOriginal,
  Personality as PersonalityOriginal,
  PersonalityWithLiterals as PersonalityWithLiteralsOriginal,
  CreateChatSettingsRequest as CreateChatSettingsRequestOriginal,
  CreateChatSettingsResponse as CreateChatSettingsResponseOriginal,
  UpdateChatSettingsRequest as UpdateChatSettingsRequestOriginal,
  UpdateChatSettingsResponse as UpdateChatSettingsResponseOriginal,
  DeleteChatSettingsRequest as DeleteChatSettingsRequestOriginal,
  DeleteChatSettingsResponse as DeleteChatSettingsResponseOriginal,
  GetChatSettingsRequest as GetChatSettingsRequestOriginal,
  GetChatSettingsResponse as GetChatSettingsResponseOriginal,
  QueryChatSettingsRequest as QueryChatSettingsRequestOriginal,
  CursorQuery as CursorQueryOriginal,
  CursorQueryPagingMethodOneOf as CursorQueryPagingMethodOneOfOriginal,
  Sorting as SortingOriginal,
  SortOrder as SortOrderOriginal,
  SortOrderWithLiterals as SortOrderWithLiteralsOriginal,
  CursorPaging as CursorPagingOriginal,
  QueryChatSettingsResponse as QueryChatSettingsResponseOriginal,
  CursorPagingMetadata as CursorPagingMetadataOriginal,
  Cursors as CursorsOriginal,
  DomainEvent as DomainEventOriginal,
  DomainEventBodyOneOf as DomainEventBodyOneOfOriginal,
  EntityCreatedEvent as EntityCreatedEventOriginal,
  RestoreInfo as RestoreInfoOriginal,
  EntityUpdatedEvent as EntityUpdatedEventOriginal,
  EntityDeletedEvent as EntityDeletedEventOriginal,
  ActionEvent as ActionEventOriginal,
  Empty as EmptyOriginal,
  MessageEnvelope as MessageEnvelopeOriginal,
  IdentificationData as IdentificationDataOriginal,
  IdentificationDataIdOneOf as IdentificationDataIdOneOfOriginal,
  WebhookIdentityType as WebhookIdentityTypeOriginal,
  WebhookIdentityTypeWithLiterals as WebhookIdentityTypeWithLiteralsOriginal,
  AccountInfo as AccountInfoOriginal,
} from './forms-ai-v1-chat-settings-chat-settings.types.js';
